import React from 'react';
import styled from 'styled-components';
import { detect } from 'detect-browser';
import SLink from '../../../ui/styled/SLink';

const detectedBrowser = detect();

const SGetMyPinLink = styled(SLink)(
  ({ theme }) => `
  font-size: ${theme.font.size.smallMedium2};
  text-decoration: underline;
  color : ${theme.colors.primaryLightBlue}
`
);

export enum PDFStrategies {
  newTab = 1,
  download = 2,
}

function base64toBlob(base64Data: string, contentType: string) {
  const selectedContentType = contentType || '';
  const sliceSize = 1024;
  const byteCharacters = atob(base64Data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: selectedContentType });
}

function blobUrl(content: string, mimeType: string) {
  const blob = base64toBlob(content, mimeType);
  return URL.createObjectURL(blob);
}

function pickPDFDisplayStrategy(): PDFStrategies {
  const browser = detectedBrowser?.name;

  switch (browser) {
    case 'firefox':
    case 'chrome':
    case 'edge-chromium':
    case 'safari':
    case 'ios':
      return PDFStrategies.newTab;
    case 'edge':
    case 'ie':
    default:
      return PDFStrategies.download;
  }
}

interface IPDFOpenProps {
  pdfPlainData: string;
  children: JSX.Element | string;
  pdfStrategy?: PDFStrategies;
}

export default ({ pdfPlainData, pdfStrategy, children }: IPDFOpenProps) => {
  const strategy = pdfStrategy ? pdfStrategy : pickPDFDisplayStrategy();
  const adjustedPDF = blobUrl(pdfPlainData, 'application/pdf');

  switch (strategy) {
    case PDFStrategies.newTab:
      return (
        <SGetMyPinLink data-at="pincodeLink" target="_blank" onClick={() => window.open(adjustedPDF, '_blank')}>
          {children}
        </SGetMyPinLink>
      );
    case PDFStrategies.download:
    default:
      return (
        <SGetMyPinLink data-at="pincodeLink" download="pinCode.pdf" target="_blank" href={adjustedPDF}>
          {children}
        </SGetMyPinLink>
      );
  }
};
